import { Link } from 'react-router-dom';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Logo Section */}
        <div className="footer-section">
          <Link to="/" className="footer-logo-link">
            <img
              src={process.env.PUBLIC_URL + '/DIGITAL-FLAVOR-LOGO.png'}
              alt="Digital Flavor"
              className="footer-logo"
            />
          </Link>
          <p className="footer-tagline">Bold flavors. Simple recipes.</p>
        </div>

        {/* Explore Section */}
        <div className="footer-section">
          <h3 className="footer-heading">EXPLORE</h3>
          <nav className="footer-links">
            <Link to="/">Home</Link>
            <Link to="/recipes/all">All Recipes</Link>
            <Link to="/meals-of-the-day">Meals of the Day</Link>
            <Link to="/budget-friendly">Budget-Friendly</Link>
          </nav>
        </div>

        {/* Account Section */}
        <div className="footer-section">
          <h3 className="footer-heading">ACCOUNT</h3>
          <nav className="footer-links">
            <Link to="/login">Log In</Link>
            <Link to="/user/profile">My Profile</Link>
            <Link to="/recipes/myrecipes">My Recipes</Link>
            <Link to="/recipes/savedrecipes">Saved Recipes</Link>
          </nav>
        </div>

        {/* Info Section */}
        <div className="footer-section">
          <h3 className="footer-heading">INFO</h3>
          <nav className="footer-links">
            <Link to="/about">About Us</Link>
          </nav>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} DIGITAL FLAVOR. ALL RIGHTS RESERVED.</p>
      </div>
    </footer>
  );
}

export default Footer;
